import React from 'react';
import { IdsButton, IdsSectionNotice } from '@investec/ids-web-react';
import { formatDate } from '../../utils/helpers';
import { getMaturityNoticeConfig, maturityNoticeVariants } from './MaturityNoticeConfig';
import { useFeatureFlags } from '../FeatureFlags/withFeatureFlags';

/**
 * @param {{
 *   account: any;
 *   variant?: string;
 *   isMultiple?: boolean;
 *   onAction?: (id: string, code: string) => void;
 *   className?: string;
 * }} props
 */
const MaturityNotice = ({
    account,
    variant = maturityNoticeVariants.Dashboard,
    isMultiple = false,
    onAction,
    className = '',
}) => {
    if (!account) {
        return null;
    }

    const [isFeatureEnabled] = useFeatureFlags();
    const noticeConfig = getMaturityNoticeConfig({
        account,
        variant,
        isMultiple,
        enableUpdatedMaturityCopy: isFeatureEnabled('EnableDashboardMaturityCopyUpdate'),
    });
    const button = noticeConfig.buttonText && onAction ? (
        <IdsButton size="sm" onClick={() => onAction(account.id, account.product.code)}>
            {noticeConfig.buttonText}
        </IdsButton>
    ) : null;

    return (
        <div className={className}>
            <IdsSectionNotice title={noticeConfig.title} buttons={button}>
                {noticeConfig.body}
                {noticeConfig.showMaturityDate && account.maturity && (
                    <p className="new-maturity-banner__date">
                        Maturing on {formatDate(new Date(account.maturity.maturityDate))}
                    </p>
                )}
            </IdsSectionNotice>
        </div>
    );
};

export default MaturityNotice;